import { action, observable } from 'mobx';

import BaseStore from '../base-store';

abstract class ArrayStore<T = any, E = unknown> extends BaseStore<E> {
  @observable readonly data = observable.array<T>([]);

  @action.bound
  public clear(): void {
    this.data.clear();
  }

  @action.bound
  protected onLoad(data: T[]): T[] {
    this.loading = false;
    this.error = undefined;

    this.data!.replace(data);

    return data;
  }

  @action.bound
  protected onError(error: E) {
    this.loading = false;
    this.error = error;
  }
}

export default ArrayStore;
